import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({
    reason: z.string().nullable().optional(),
});

export const runInterruptedDefinitions = {
    run_interrupted: defineInvisible('run_interrupted', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence(_payload, occurrence) {
            if (occurrence.committed === null) {
                return null;
            }
            return {
                kind: 'run_terminal',
                eventId: occurrence.committed.id,
                occurredAtMs: Date.parse(occurrence.committed.created_at),
            };
        },
    }),
} as const;

export const runInterruptedContractFixtures = {
    valid: {
        type: 'run_interrupted',
        reason: 'interruption-reason-sentinel',
    },
    malformed: {
        type: 'run_interrupted',
        reason: 3,
    },
} as const;
